import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { GET } from '../../utils/requests';
import { debounce } from "../../utils/debounce";

const Main = ({ default_value, show_address, value, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (default_value) {
      getVendorByID(default_value)
    }
  }, [])

  const doDebouncedSearch = (searchTerm) => getSearchVendors(searchTerm)

  const debouncedFetchData = debounce(doDebouncedSearch, 500);

  const getSearchVendors = (searchTerm) => {
    GET({
      url: `/references/vendors.json?query=${searchTerm}`,
      success: (data) => setOptions(data.records)
    })
  }

  const getVendorByID = (id) => {
    GET({
      url: `/references/vendors/${id}.json`,
      success: (data) => doSetValue(data)
    })
  }

  const onSearch = (newValue) => {
    debouncedFetchData(newValue)
  }

  const onLocalChange = (newValue) => {
    doSetValue(newValue)
  }

  const doSetValue = (newValue) => {
    if(onChange) {
      onChange(newValue)
    }
  }

  return (
    <>
      <Autocomplete
        value={value}
        options={options}
        sx={{ width: "100%" }}
        getOptionLabel={(option) => typeof option === 'string' ? option : option.name}
        filterOptions={(x) => x}
        autoComplete
        includeInputInList
        filterSelectedOptions
        noOptionsText="No locations"
        onChange={(event, newValue) => {
          onLocalChange(newValue)
        }}
        onInputChange={(event, newInputValue) => {
          onSearch(newInputValue)
        }}
        renderInput={(params) => (
          <TextField {...params} label="Vendor" fullWidth />
        )}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Grid container sx={{ alignItems: 'center' }}>
                <Grid item sx={{ width: 'calc(100% - 44px)', wordWrap: 'break-word' }}>
                  <Typography variant="h7" sx={{ color: 'text.primary' }}>
                    {option.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {option.address}
                  </Typography>
                </Grid>
              </Grid>
            </li>
          );
        }}
      />
      {show_address && value && 
        <div className="alert alert-info mt-2 p-2 px-3 mb-0" role="alert">
          ({value.id}) : {value.address}
        </div>
      }
    </>
  )
}

export default Main;
